import { RegionsEnum } from '../enums/RegionsEnum';
import { ModuleEnum } from '../enums/ModuleEnum';
import { LocalizedAttributeNames } from '../interfaces/AttributesClassInterface';

export type ReplacementAttrName = LocalizedAttributeNames;
export type ReplacementAccessoryAttrName = LocalizedAttributeNames;
export type ReplacementNoteAttrName = LocalizedAttributeNames;
export type ReplacementAttributesEntry = [
    ReplacementAttrName,
    ReplacementAccessoryAttrName[],
    ReplacementNoteAttrName
] | [
    ReplacementAttrName,
    ReplacementAccessoryAttrName[],
];
export type ReplacementAttributes = ReplacementAttributesEntry[];

export const createReplacementConfig = (region: RegionsEnum): Record<ModuleEnum, ReplacementAttributes> => {
    const replacementsForAP: ReplacementAttributes = region === RegionsEnum.ap
        ? [['7240', ['7242'], '7241']]
        : [];
    const actuatorReplacements: ReplacementAttributes = [
        ...replacementsForAP,
        ['7597', ['7604'], '7881'],
        ['7680', ['7697'], '7882'],
        ['7688', ['7698'], '7883'],
        ['7704', ['7705'], '7884'],
        ['7708', ['8517'], '8516'],
        ['3477', ['7766'], '7765'],
    ];
    return {
        [ModuleEnum.vau]: [
            ['7603', ['7706'], '7672']
        ],
        [ModuleEnum.ValveSizer]: [],
        [ModuleEnum.findByDesign]: [],
        [ModuleEnum.AirSolution]: [],
        [ModuleEnum.WaterSolution]: [],
        [ModuleEnum.SensorSolution]: [],
        [ModuleEnum.ValveSolution]: [
            ['7598', ['7707'], '7631'],
            ['7655', ['7710'], '7656'],
        ],
        [ModuleEnum.Accessory]: [
            ['7767', ['7798'], '7768'],
        ],
        [ModuleEnum.water]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.waterByValve]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.air]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.ActuatorSizer]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.FireAndSmokeSolution]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.FireAndSmoke]: [
            ...actuatorReplacements
        ],
        [ModuleEnum.sensor]: [
            ['8404', ['7777'], '8263'],
            ['8405', ['7778'], '8264'],
            ['8465', ['7711'], '8265'],
            ['8466', ['7712'], '8266'],
        ],
        [ModuleEnum.SensorSizer]: [
            ['8404', ['7777'], '8263'],
            ['8405', ['7778'], '8264'],
            ['8465', ['7711'], '8265'],
            ['8466', ['7712'], '8266'],
        ],
    }
}

export const ReplacementAttributesList: ReplacementAttrName[] = Object.values(createReplacementConfig(RegionsEnum.ap)).reduce(
    (acc, curr) => {
        curr.forEach((row) => {
            const [attrName] = row;
            if (!acc.includes(attrName)) {
                acc.push(attrName);
            }
        });
        return acc;
    },
    [] as ReplacementAttrName[],
);
